import { gql } from '@apollo/client';

export const UPLOAD_FEEDBACK_FILE = gql`
  mutation UploadFeedbackFile {
    uploadFeedbackFile {
      success
      error
      url
    }
  }
`;

export const SUBMIT_CUSTOMER_FEEDBACK = gql`
  mutation SubmitCustomerFeedback(
    $title: String!
    $description: String
    $priority: Int
    $currentUrl: String
    $attachmentUrls: [String]
  ) {
    submitCustomerFeedback(
      title: $title
      description: $description
      priority: $priority
      currentUrl: $currentUrl
      attachmentUrls: $attachmentUrls
    ) {
      success
      error
      issue {
        id
        identifier
        title
        url
      }
    }
  }
`;

export const GET_CUSTOMER_REQUESTS = gql`
  query GetCustomerRequests {
    customerRequests {
      success
      error
      customerName
      requests {
        id
        title
        description
        status
        statusType
        priority
        url
        createdAt
        updatedAt
      }
    }
  }
`;
